import { NgModule } from '@angular/core';
import { provideRouter, RouterModule } from '@angular/router';
import { CoreEffects } from '@next/core-lib';
import { provideAgrAdvisorRelationshipsSelector } from '@next/core-lib/advisor-relationships-selector';
import { provideAgrCore } from '@next/core-lib/app';
import { BrandingService } from '@next/core-lib/branding';

import { I18nBrowserEffects } from '@next/core-lib/browser';
import { provideAgrElasticApi } from '@next/core-lib/elastic';
import { I18nEffects } from '@next/core-lib/i18n';
import { NavigationEffects } from '@next/core-lib/navigation';
import { provideAgrRouterStore } from '@next/core-lib/router-store';
import { SiteEffects } from '@next/core-lib/site';
import { AgrWrapperSiteSidenavModule } from '@next/core-lib/wrapper-site-sidenav';

import { provideEffects } from '@ngrx/effects';
import { provideState, provideStore } from '@ngrx/store';

import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';
import * as brandingReducer from './branding/store/branding.reducer';
import { DeliveryModule } from './delivery/delivery.module';
import { FeedAdviceModule } from './feed-advice/feed-advice.module';
import { FlockModule } from './flock/flock.module';
import { ProductModule } from './product/product.module';
import { ReferenceSchemeModule } from './reference-scheme/reference-scheme.module';
import { SettingsModule } from './settings/settings.module';
import { PwaBrandingService } from './shared/pwa/pwa-branding.service';
import { SharedModule } from './shared/shared.module';
import { LayerEffects } from './shared/store/layer.effects';

@NgModule({
  declarations: [AppComponent],
  imports: [
    RouterModule,
    SharedModule,
    FlockModule,
    ProductModule,
    SettingsModule,
    DeliveryModule,
    FeedAdviceModule,
    ReferenceSchemeModule,
    AgrWrapperSiteSidenavModule,
  ],
  providers: [
    provideRouter(appRoutes),
    provideStore(),
    provideAgrRouterStore(),
    provideAgrCore(),
    { provide: BrandingService, useClass: PwaBrandingService },
    provideAgrElasticApi(),
    provideAgrAdvisorRelationshipsSelector(),
    provideState('brandingState', brandingReducer.reducer),
    provideEffects([
      LayerEffects,
      CoreEffects,
      I18nEffects,
      I18nBrowserEffects,
      SiteEffects,
      NavigationEffects,
    ]),
  ],
})
export class AppModule {}
